<div class="row">
  <div class="col-lg-1 col-12 px-0">
    <app-uiform-side-menu [uiformId]="uiformId" [targetId]="target_name" [usecaseId]="usecaseId">
    </app-uiform-side-menu>
  </div>
  <div class="col-lg-11 col-12 my-margin-left" #content>
    <div class="row">
      <div class="col-md-12 mb-1">
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div class="breadcrumb-title border-0 mb-3">
            <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div class="d-flex align-items-center">
                <mat-icon color="primary">pie_chart</mat-icon>
                <p class="ms-2 mb-0">
                  {{ form.data["title"] }}
                  {{ target_name == "chart-custom" ? "Dynamic" : "Quick" }} Chart
                </p>
              </div>

              <!-- Field + Buttons -->
              <!-- <div class="" *ngIf="target_name != 'chart-custom'">
              <div
                class="d-flex flex-sm-row flex-wrap flex-md-nowrap align-items-stretch align-items-sm-center justify-content-start gap-2">
              
                <div class="input-group flex-grow-1 input-width" style="min-width: 250px;">
                  <button class="btn btn-outline-primary btn-sm flex-shrink-0">
                    Field
                  </button>
                  <select class="form-select form-select-sm flex-grow-1" id="SelectAttributes" name="SelectAttributes"
                    [(ngModel)]="form.data['field']" [ngClass]="{
                                  'placeholder-grey':
                                    form.data['field'] === undefined ||
                                    form.data['field'] === 'undefined'
                                }" #SelectAttributes>
                    <option selected value="undefined">--Select--</option>
                    <option *ngFor="let e of filterAttributeLabel()" [value]="e['code']">
                      {{ e["label"] }}
                    </option>
                  </select>
                </div>

             
                <div class="d-flex flex-wrap flex-md-nowrap gap-2">
                  <button class="pdf-exclude btn btn-outline-primary btn-sm" (click)="drawChart()"
                    [disabled]="form.data['field'] === 'undefined'" title="Draw" *ngIf="target_name != 'chart-custom'">
                    Draw
                  </button>

                  <button (click)="getUsecaseSchema(); resetSearchValues()" title="Refresh"
                    class="pdf-exclude btn btn-outline-primary btn-sm" *ngIf="target_name != 'chart-custom'">
                    <i class="fa fa-sync"></i>
                  </button>

                  <button (click)="downloadPDF()" title="PDF" class="pdf-exclude btn btn-outline-primary btn-sm">
                    <i class="fa fa-file-pdf"></i>
                  </button>
                </div>
              </div>
            </div> -->
            </div>
          </div>
          <div *ngIf="target_name != 'chart-custom'" class="compact-inputs dropdown-pd-none">
            <div class="d-flex gap-3 align-items-center">
              <!-- Field Select -->
              <div>
                <mat-form-field appearance="outline" class="w-100" style="min-width: 250px;">
                  <mat-label>{{'ALLREMAININGS.Field' | translate}}</mat-label>
                  <mat-select [(ngModel)]="form.data['field']" name="SelectAttributes" #SelectAttributes>
                    <mat-option value="undefined">{{'ALLREMAININGS.Select' | translate}}</mat-option>
                    <mat-option *ngFor="let e of filterAttributeLabel()" [value]="e['code']">
                      {{ e["label"] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Buttons -->
              <div class="d-flex gap-2 flex-wrap">
                <!-- Draw Button -->
                <button mat-stroked-button color="primary" (click)="drawChart()" class="icon-center icon-width"
                  [disabled]="form.data['field'] === 'undefined'" matTooltip="{{'ALLREMAININGS.Draw'| translate}}">
                  <mat-icon>show_chart</mat-icon>
                  <span class="ms-2">{{'ALLREMAININGS.Draw'| translate}}</span>
                </button>

                <!-- Refresh Button -->
                <button mat-stroked-button color="primary" (click)="getUsecaseSchema(); resetSearchValues()"
                  class="icon-center icon-width" matTooltip="{{'ALLREMAININGS.Refresh'| translate}}">
                  <mat-icon>refresh</mat-icon>
                </button>

                <!-- PDF Button -->
                <button mat-stroked-button color="primary" (click)="downloadPDF()" matTooltip="PDF"
                  class="icon-center icon-width">
                  <mat-icon>picture_as_pdf</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-dynamic-chart *ngIf="target_name == 'chart-custom'" [attributes]="usecaseAttributes" [data]="usecaseData"
        [collection_name]="usecase?.['collectionName']" />
      <div *ngIf="target_name != 'chart-custom'">
        <div *ngIf="loading">loading ...</div>
        <div class="row" *ngIf="!loading">
          <div *ngIf="usecaseData && usecaseData.length > 0">
            <div class="row mt-3">
              <ng-container *ngFor="let field of filterFieldsAttributes(); let i = index">
                <!-- Line or Bar Chart -->
                <div class="col-lg-6 col-md-12 mb-3 px-2" [ngClass]="{'col-12': isLastOdd(i)}">
                  <div class="card shadow-sm chartcardheight">
                    <div class="card-header">
                      <h6 class="d-flex gap-2 align-items-center mb-0">
                        <span>{{ field.label }}</span>
                        <i *ngIf="field.type === 'date' || field.type === 'time'"
                          class="bi bi-bar-chart-line text-primary"></i>
                        <i *ngIf="field.type !== 'date' && field.type !== 'time'"
                          class="bi bi-bar-chart text-primary"></i>
                      </h6>
                    </div>
                    <div class="card-body">
                      <app-ncs-graph [attributes]="filterFieldsAttributes()" [data]="usecaseData"
                        [collectionName]="usecase?.['collectionName']" [field]="field"
                        [chartType]="field.type === 'date' || field.type === 'time' ? 'line' : 'bar'">
                      </app-ncs-graph>
                    </div>
                  </div>
                </div>
                <!-- Pie Chart -->
                <div class="col-lg-6 col-md-12 mb-3 px-2"
                  *ngIf="field.type !== 'date' && field.type !== 'time' && usecaseData.length < 10"
                  [ngClass]="{'col-12': isLastOdd(i+1)}">
                  <div class="card shadow-sm chartcardheight">
                    <div class="card-header">
                      <h6 class="d-flex gap-2 align-items-center mb-0">
                        <span>{{ field.label }}</span>
                        <i class="bi bi-pie-chart-fill text-primary" title="Pie Chart"></i>
                      </h6>
                    </div>
                    <div class="card-body">
                      <app-ncs-graph [attributes]="filterFieldsAttributes()" [data]="usecaseData"
                        [collectionName]="usecase?.['collectionName']" [field]="field" [chartType]="'pie'">
                      </app-ncs-graph>
                    </div>
                  </div>
                </div>
                <!-- Doughnut Chart -->
                <div class="col-lg-6 col-md-12 mb-3 px-2"
                  *ngIf="field.type !== 'date' && field.type !== 'time' && usecaseData.length < 10"
                  [ngClass]="{'col-12': isLastOdd(i+2)}">
                  <div class="card shadow-sm chartcardheight">
                    <div class="card-header">
                      <h6 class="d-flex gap-2 align-items-center mb-0">
                        <span>{{ field.label }}</span>
                        <i class="bi bi-opencollective text-primary" title="Doughnut Chart"></i>
                      </h6>
                    </div>
                    <div class="card-body">
                      <app-ncs-graph [attributes]="filterFieldsAttributes()" [data]="usecaseData"
                        [collectionName]="usecase?.['collectionName']" [field]="field" [chartType]="'doughnut'">
                      </app-ncs-graph>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>